import { validateEnv } from './validateEnv'
import { getApiBaseUrl } from 'config/apiBaseUrl'

export const env = import.meta.env.MODE

const envVars = validateEnv(import.meta.env)

export const version = envVars.VITE_VERSION

export const auth0 = {
  domain: envVars.VITE_AUTH0_DOMAIN,
  clientId: envVars.VITE_AUTH0_CLIENT_ID,
}

export const apiEndpoints = {
  irwinBaseUrl: envVars.VITE_IRWIN_BASE_URL,
  kongLimaBaseUrl: envVars.VITE_KONG_LIMA_BASE_URL,
}

export const irwin = {
  get baseUrl() {
    return getApiBaseUrl()
  },
  appUrl: envVars.VITE_IRWIN_APP_URL,
}

export const factset = {
  baseUrl: envVars.VITE_FACTSET_BASE_URL,
  authDomain: envVars.VITE_FACTSET_AUTH_DOMAIN,
  authLogoutUrl: `https://${envVars.VITE_FACTSET_AUTH_DOMAIN}/logout?cleanIdpId=true`,
  oidcAuthority: envVars.VITE_FACTSET_OIDC_AUTHORITY,
  oidcClientId: envVars.VITE_FACTSET_OIDC_CLIENT_ID,
}

// The feature-flag proxy URL falls back to the raw VITE_IRWIN_BASE_URL, never irwin.baseUrl —
// the flag client must always reach Irwin directly, never through Kong/LIMA.
export const featureFlagConfig = {
  url: `${envVars.VITE_FEATURE_FLAGS_BASE_URL || envVars.VITE_IRWIN_BASE_URL}/admin/feature/flags/proxy`,
  clientKey: envVars.VITE_FEATURE_FLAGS_KEY,
  refreshInterval: 600,
  appName: 'admin-fe',
  environment: env,
}

export const mui = { dataGridKey: envVars.VITE_MUI_DATAGRID_KEY }

export const aws = { geoplacesApiKey: envVars.VITE_GEOPLACES_API_KEY }
